var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creative-dashboard"},[_c('Dashboard'),_c('CreateNewOrder'),_c('CreateNewCampaign'),_c('OrderActionsDelete'),_c('OrderActionsEdit'),_c('ActiveStatusConfirmationPopup'),_c('ShowCampaign'),_c('CampaignActionsDelete'),_c('CampaignActionsEdit'),_c('DatePicker')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }